import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import backgroundImage from '../../assets/img/hero/hero-1.jpeg';
import './landingpage.css';

const LandingPage = () => {
  return (
    <div className="landing-page-container">
      <div className="background-image" style={{ backgroundImage: 'url(' + backgroundImage + ')' }}>
        <div className="overlay-content">
          <h1 className="heading">
            Let My Lens Narrate Your Story
          </h1>
          <p className="description">
            Capturing moments that transcend time and space, I specialize in turning ordinary scenes into extraordinary tales
          </p>
          <Link to="/bookingpage">
            <motion.button
              whileHover={{ scale: 1.05 }}
              className="primary-button"
            >
              Book A Call Now!
            </motion.button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;